import { ComponentPropsWithRef, ComponentType, PropsWithChildren } from 'react';

export type ProductsElementName = 'productNameLink' | 'productPhotoLink' | 'productRatingLink';

export enum ProductUIElementsVisibility {
  None = 0,
  Buttons = 1,
  PriceStatus = 2,
  Reviews = 4,
  ProductID = 8,
  OnlineOrderOnly = 16,
  All = 31,
}

export type ProductCardPropsWithContainer = {
  Container: ComponentType<PropsWithChildren<ComponentPropsWithRef<'div'>>>;
  ImageContainer: ComponentType<PropsWithChildren>;

  productNameClassName?: string;
  mainPriceClassName?: string;
  fractPriceClassName?: string;
  infoWrapperClassName?: string;
};
